import * as Yup from 'yup';

// Sprint 28, story-143. Validation-error copy is in scope per AC4, not just static labels —
// docs/ux/story-143-design.md. Schemas become functions of the `login` locale section so each
// call site builds them with `useMemo(() => loginSchema(tLogin), [tLogin])`.
type LoginMessages = {
  invalidEmail: string;
  emailRequired: string;
  passwordRequired: string;
  codeRequired: string;
  passwordComplexity: string;
  confirmPasswordRequired: string;
  passwordsDoNotMatch: string;
};

export const loginSchema = (t: LoginMessages) =>
  Yup.object({
    email: Yup.string().email(t.invalidEmail).required(t.emailRequired),
    password: Yup.string().required(t.passwordRequired),
  });

export const resetPasswordSchema = (t: LoginMessages) =>
  Yup.object({
    email: Yup.string().email(t.invalidEmail).required(t.emailRequired),
    confirmationCode: Yup.string().required(t.codeRequired),
    newPassword: Yup.string()
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/,
        t.passwordComplexity,
      )
      .required(t.passwordRequired),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('newPassword')], t.passwordsDoNotMatch)
      .required(t.confirmPasswordRequired),
  });

export const forceResetPasswordSchema = (t: LoginMessages) =>
  Yup.object({
    email: Yup.string().email(t.invalidEmail).required(t.emailRequired),
    newPassword: Yup.string()
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/,
        t.passwordComplexity,
      )
      .required(t.passwordRequired),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('newPassword')], t.passwordsDoNotMatch)
      .required(t.confirmPasswordRequired),
  });

export const forgotPasswordSchema = (t: LoginMessages) =>
  Yup.object({
    email: Yup.string().email(t.invalidEmail).required(t.emailRequired),
  });
